export const REGIONI = [
  "Abruzzo", "Basilicata", "Calabria", "Campania", "Emilia-Romagna",
  "Friuli-Venezia Giulia", "Lazio", "Liguria", "Lombardia", "Marche",
  "Molise", "Piemonte", "Puglia", "Sardegna", "Sicilia", "Toscana",
  "Trentino-Alto Adige", "Umbria", "Valle d'Aosta", "Veneto",
];

export const ATECO = [
  { code: "62.01", label: "62.01 - Produzione di software" },
  { code: "62.09", label: "62.09 - Altre attività dei servizi IT" },
  { code: "63.11", label: "63.11 - Elaborazione dati e hosting" },
  { code: "72.19", label: "72.19 - Ricerca e sviluppo (altre scienze)" },
  { code: "26.20", label: "26.20 - Fabbricazione di computer e periferiche" },
  { code: "28.99", label: "28.99 - Fabbricazione di macchinari" },
  { code: "25.62", label: "25.62 - Lavori di meccanica generale" },
  { code: "10.71", label: "10.71 - Produzione prodotti da forno" },
  { code: "47.91", label: "47.91 - Commercio al dettaglio online" },
  { code: "55.10", label: "55.10 - Alberghi e strutture ricettive" },
  { code: "56.10", label: "56.10 - Ristorazione" },
  { code: "41.20", label: "41.20 - Costruzione di edifici" },
  { code: "13.10", label: "13.10 - Preparazione e filatura fibre tessili" },
  { code: "20.59", label: "20.59 - Fabbricazione prodotti chimici" },
  { code: "86.90", label: "86.90 - Servizi sanitari" },
  { code: "70.22", label: "70.22 - Consulenza gestionale" },
];

export const DIMENSIONI = ["Microimpresa", "Piccola Impresa", "Media Impresa", "Grande Impresa"];

export const DIPENDENTI = ["1-9", "10-49", "50-249", "250+"];

export const FATTURATO = ["< 2M€", "2M€ - 10M€", "10M€ - 50M€", "> 50M€"];

export const FORME_GIURIDICHE = [
  "SRL", "SRLS", "SPA", "SAS", "SNC", "Ditta Individuale",
  "Startup Innovativa", "Cooperativa", "Impresa Sociale",
];

export const OBIETTIVI = [
  "Transizione 5.0", "Digitalizzazione & AI", "Internazionalizzazione",
  "Sostenibilità ESG", "Ricerca & Sviluppo", "Nuove Assunzioni",
  "Efficienza Energetica", "Nuovi Macchinari", "Formazione del Personale",
  "Brevetti & Proprietà Intellettuale",
];

export function scoreTone(score) {
  if (score >= 80) return { label: "Alta compatibilità", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", bar: "bg-emerald-500" };
  if (score >= 50) return { label: "Media compatibilità", cls: "bg-amber-50 text-amber-700 border-amber-200", bar: "bg-amber-500" };
  return { label: "Bassa compatibilità", cls: "bg-slate-100 text-slate-600 border-slate-200", bar: "bg-slate-400" };
}

export function statoTone(stato) {
  const s = (stato || "").toLowerCase();
  if (s.includes("scadenza")) return "bg-amber-50 text-amber-700 border-amber-200";
  if (s.includes("arrivo")) return "bg-blue-50 text-blue-700 border-blue-200";
  return "bg-emerald-50 text-emerald-700 border-emerald-200";
}

export function etichettaFor(grant) {
  const label = grant?.etichetta ||
    ((grant?.compatibilita || 0) >= 75 ? "Compatibile" : "Potenzialmente compatibile");
  if (label === "Compatibile") {
    return { label, cls: "bg-emerald-600 text-white", dot: "bg-emerald-200" };
  }
  return { label, cls: "bg-amber-500 text-white", dot: "bg-amber-200" };
}

export function fmtCheckDate(iso) {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return null;
  }
}

export const FEEDBACK_OPTIONS = [
  { key: "pertinente", label: "Pertinente", icon: "ThumbsUp", cls: "text-emerald-600 bg-emerald-50 border-emerald-200" },
  { key: "scaduto", label: "Scaduto", icon: "Clock", cls: "text-amber-600 bg-amber-50 border-amber-200" },
  { key: "falso_positivo", label: "Falso positivo", icon: "ThumbsDown", cls: "text-red-600 bg-red-50 border-red-200" },
];
